<template>
    <IndexBase @auth="onAuth($event)" action="Index" controller="Order"></IndexBase>

    <Card>
        <template #title>
            <Toolbar>
                <template #left>
                    <div class="p-card-title">
                        {{$t('order')}}

                        <Button icon="pi pi-refresh" class="p-button-rounded p-button-info p-button-outlined ml-2" @click="loadLazyData"/>
                    </div>
                </template>

                <template #right>
                    <div v-if="isUser">
                        <span class="p-buttonset">
                            <ViewShipments :data="selectedRow" v-if="canViewShipments && canView" @close="onModalClose" @message="sidebarMessage($event)" />
                            <Button :data="selectedRow" v-if="canViewOrder && canView" @close="onModalClose" @message="sidebarMessage($event)" @click="viewOrder" icon="pi pi-eye" class="p-button-sm p-button-primary" :label="$t('view_order')" />
                            <History :pData="selectedRow" v-if="canViewHistory && canView" @close="onModalClose" @message="sidebarMessage($event)" />
                        </span>

                        <span class="p-buttonset">
                            <EditOrder :data="selectedRow" v-if="canEditOrder && canEdit"  @message="sidebarMessage" @close="onModalClose" />
                            <EditAssign :data="selectedRow" v-if="canEditAssignTransporter && canEdit" @close="onModalClose" @message="sidebarMessage" />
                            <ChangeStuffingDate :data="selectedRow" v-if="canEditStuffingDate && canEdit" @close="onModalClose"/>
                        </span>

                        
                            
                    </div>
                    <div v-else-if="isTransporter" class="mr-2">
                        <ViewShipments :data="selectedRow" v-if="canViewShipments && canView" @close="onModalClose" @message="sidebarMessage($event)"/>
                    </div>
                    
                    <AssignDriver :data="selectedRow" v-if="(isUser || isTransporter) && canAssignDriver && canCreate" @close="onModalClose" @message="sidebarMessage($event)" />
                    <Merge :pData="selectedRow" v-if="(isUser || isTransporter) && canMerge && canCreate" @close="onModalClose" @message="sidebarMessage($event)" />
                    <TransporterAction :pData="selectedRow" v-if="(isUser || isTransporter) && needTransporterAction && canEdit" @close="onModalClose" />
                    <CancelOrder :data="selectedRow" v-if="isUser && canCancelOrder && canEdit" @close="onModalClose" />
                    <!-- <ReassignDO :data="selectedRow" v-if="isUser && canReassignDO" @close="onModalClose" /> -->
                    <MarkComplete :data="selectedRow" v-if="isUser && (canMarkComplete || canUnmarkComplete) && canEdit" @close="onModalClose" :canMarkComplete="canMarkComplete" :canUnmarkComplete="canUnmarkComplete" />
                </template>
            </Toolbar>
        </template>
        <template #content>
            <div class="p-fluid mb-3">
                <CustomSelectButton v-model="selectedStatus" :options="statusList" optionLabel="text" optionValue="id" class="p-text-center" @change="onChangeStatus">
                    <template #option="slotProps">
                        <div class="p-text-center" style="width:100%">
                            <b>{{slotProps.option.text}}</b>
                        </div>
                    </template>
                </CustomSelectButton>
            </div>

            <DataTable ref="dt" responsiveLayout="scroll" class="p-datatable-sm" filterDisplay="row" sortMode="multiple" removableSort
                       v-model:expandedRows="expandedRows"
                       stateStorage="local"
                       :stateKey="stateKey"
                       :value="dataModel" :loading="!dataModel || loading"
                       :paginator="true"
                       :rows="15"
                       :lazy="true"
                       v-model:first="this.start"
                       scrollHeight="70vh"
                       wrapperClass="responsive-height"
                       @rowExpand="onRowExpand"
                       @state-restore="onStateRestore($event)"
                       @page="onPage($event)"
                       @sort="onSort($event)"
                       @filter="onFilter($event)"
                       @update:selection="onSelect($event)"
                       v-model:filters="filters"
                       :totalRecords="totalRecords"
                       v-model:selection="selectedRow" 
                       selectionMode="multiple" 
                       dataKey="Id" 
                       :metaKeySelection="false" 
                    >
                <template #empty>
                    No records found
                </template>
                <Column :exportable="false" :sortable="false" :expander="true" headerStyle="width: 1rem">
                    <template #header="">
                        <!-- <Button v-show="canCreate" label="Create" icon="pi pi-plus" class="p-button-primary p-button-sm" @click="editor(this.$FORM_MODE_CREATE, 0)" /> -->
                    </template>
                    <template #filter>
                        <Button :label="$t('clear')" icon="pi pi-filter-slash" class="p-button-outlined p-button-primary p-button-sm" @click="clearFilter" :badge="filterBadge" badgeClass="p-badge-danger" />
                    </template>
                </Column>
                <Column field="Order_No" :header="$t('order_no')" :sortable="true">
                    <template #filter="{filterModel,filterCallback}">
                        <InputText type="text" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" :placeholder="$t('order_no')" />
                    </template>
                </Column>
                <Column field="Order_Type_Name" :header="$t('order_type')" :sortable="true">
                    <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
                    <template #filter="{filterModel,filterCallback}">
                        <InputText type="text" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" :placeholder="$t('order_type')" />
                    </template>
                </Column>
                <Column field="Order_Date" :header="$t('doc_date')" dataType="date" :sortable="true">
                    <template #filter="{filterModel,filterCallback}">
                        <InputText type="text" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" :placeholder="$t('doc_date')" />
                    </template>
                     <template #body="{data}">
                        {{ this.$formatDate(data.Order_Date)}}
                    </template>
                </Column>
                <Column field="SAP_No" :header="$t('sap_no')" :sortable="true">
                    <template #filter="{filterModel,filterCallback}">
                        <InputText type="text" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" :placeholder="$t('sap_no')" />
                    </template>
                </Column>
                <Column field="Transporter_Name" :header="$t('transporter')" :sortable="true">
                    <template #filter="{filterModel,filterCallback}">
                        <InputText type="text" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" :placeholder="$t('transporter')" />
                    </template>
                </Column>
                <Column field="Loading_Destination_From_Name" :header="$t('loading')" :sortable="true">
                    <template #filter="{filterModel,filterCallback}">
                        <InputText type="text" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" :placeholder="$t('loading')" />
                    </template>
                </Column>
                <Column field="Loading_Destination_To_Name" :header="$t('destination')" :sortable="true">
                    <template #filter="{filterModel,filterCallback}">
                        <InputText type="text" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" :placeholder="$t('destination')" />
                    </template>
                </Column>
                <Column field="Business_Segment_Name" :header="$t('product_category')" :sortable="true">
                    <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
                    <template #filter="{filterModel,filterCallback}">
                        <InputText type="text" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" :placeholder="$t('product_category')" />
                    </template>
                </Column>
                <Column field="Customer_Vendor_Name" :header="$t('customer_vendor')" :sortable="true">
                    <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
                    <template #filter="{filterModel,filterCallback}">
                        <InputText type="text" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" :placeholder="$t('customer_vendor')" />
                    </template>
                </Column>
                <Column field="Delivery_Address" :header="$t('delivery_address')" :sortable="true">
                    <template #filter="{filterModel,filterCallback}">
                        <InputText type="text" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" :placeholder="$t('delivery_address')" />
                    </template>
                    <template #body="{data}">
                        {{ data.Delivery_Address ? data.Delivery_Address : data.Customer_Vendor_Address }}
                    </template>
                </Column>
                <Column field="Status" :header="$t('status')" :sortable="true">
                    <template #filter="{filterModel,filterCallback}">
                        <InputText type="text" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" :placeholder="$t('status')" :disabled="true" />
                    </template>
                </Column>
                <Column field="Dispatch_Status" :header="$t('dispatch_status')" :sortable="true">
                    <template #filter="{filterModel,filterCallback}">
                        <CustomDropdown v-if="filterModel" v-model="filterModel.value" :options="transporterStatusList" :placeholder="$t('dispatch_status')"  class="p-column-filter p-inputtext-sm" @change="filterCallback()">
                        </CustomDropdown>
                        <!-- <InputText type="text" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" :placeholder="$t('dispatch_status')" /> -->
                    </template>
                </Column>
                <Column field="Dispatch_Status_Remarks" :header="$t('dispatch_status_reason')" :sortable="true">
                    <template #filter="{filterModel,filterCallback}">
                        <InputText type="text" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" :placeholder="$t('dispatch_status_reason')" />
                    </template>
                </Column>
                <Column field="Truck_Type_Name" :header="$t('truck_type')" :sortable="true">
                    <template #filter="{filterModel,filterCallback}">
                        <InputText type="text" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" :placeholder="$t('truck_type')" />
                    </template>
                </Column>
                <Column field="shipment_type_name" :header="$t('shipment_type')" :sortable="true">
                    <template #filter="{filterModel,filterCallback}">
                        <!-- <InputText type="text" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" :placeholder="$t('shipment_type')" /> -->
                        <CustomDropdown v-if="filterModel" v-model="filterModel.value" :options="shipmentTypeList" :placeholder="$t('shipment_type')"  class="p-column-filter p-inputtext-sm" @change="filterCallback()">
                        </CustomDropdown>
                    </template>
                </Column>
                <Column field="Auto_Reject_Date" :header="$t('auto_reject_date')" dataType="date" :sortable="true">
                    <template #filter="{filterModel,filterCallback}">
                        <DatePicker dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel" :v-model="filterModel.value ? filterModel.value : null" @keydown.enter="filterCallback()" :placeholder="$t('auto_reject_date')" />
                    </template>
                    <template #body="{data}">
                        {{ this.$formatDateTime(data.Created_Date)}}
                    </template>
                </Column>
                
                <Column field="Incoterm_Name" :header="$t('incoterm')" :sortable="true">
                    <template #filter="{filterModel,filterCallback}">
                        <InputText type="text" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" :placeholder="$t('incoterm')" />
                    </template>
                </Column>
                <Column field="Incoterm2" :header="$t('incoterm2')" :sortable="true">
                    <template #filter="{filterModel,filterCallback}">
                        <InputText type="text" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" :placeholder="$t('incoterm2')" />
                    </template>
                </Column>
                <Column field="Distribution" :header="$t('distribution')" :sortable="true">
                    <template #filter="{filterModel,filterCallback}">
                        <InputText type="text" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" :placeholder="$t('distribution')" />
                    </template>
                </Column>
                <Column field="Document_Type" :header="$t('document_type')" :sortable="true">
                    <template #filter="{filterModel,filterCallback}">
                        <InputText type="text" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" :placeholder="$t('document_type')" />
                    </template>
                </Column>
                <Column field="Company_Name" :header="$t('company')">
                    <template #filter="{filterModel,filterCallback}">
                        <InputText type="text" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" :placeholder="$t('company')" />
                    </template>
                </Column>
                <Column field="Valid_From" :header="$t('valid_from')" dataType="date" :sortable="true">
                    <template #filter="{filterModel,filterCallback}">
                        <DatePicker dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" :placeholder="$t('valid_from')" />
                    </template>
                    <template #body="{data}">
                        {{ this.$formatDate(data.Valid_From)}}
                    </template>
                </Column>
                <Column field="Valid_To" :header="$t('valid_to')" dataType="date" :sortable="true">
                    <template #filter="{filterModel,filterCallback}">
                        <DatePicker dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" :placeholder="$t('valid_to')" />
                    </template>
                    <template #body="{data}">
                        {{ this.$formatDate(data.Valid_To)}}
                    </template>
                </Column>
                <Column field="has_shipment" :header="$t('has_shipment')" dataType="date" :sortable="true">
                    <template #filter="{filterModel,filterCallback}">
                        <YNSelect :placeholder="$t('has_shipment')" :useBinary="false" v-if="filterModel" v-model="filterModel.value" @change="filterCallback()"/>
                    </template>
                    <template #body="{data}">
                        {{ data.has_shipment ? "Y" : "N"}}
                    </template>
                </Column>
                <Column field="Revert_Qty" :header="$t('revert_qty')" :sortable="true">
                    <template #filter="{filterModel,filterCallback}">
                        <InputText type="text" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" :placeholder="$t('revert_qty')" />
                    </template>
                </Column>
                <Column field="Created_Date" :header="$t('created_date')" dataType="date" :sortable="true">
                    <template #filter="{filterModel,filterCallback}">
                        <DatePicker dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" :placeholder="$t('created_date')" />
                    </template>
                    <template #body="{data}">
                        {{ this.$formatDateTime(data.Created_Date)}}
                    </template>
                </Column>
                <Column field="Created_By" :header="$t('created_by')" dataType="date" :sortable="true">
                    <template #filter="{filterModel,filterCallback}">
                        <InputText type="text" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" placeholder="Filter Created By" />
                    </template>
                </Column>
                <Column field="Edited_Date" header="Edited Date" dataType="date" :sortable="true">
                    <template #filter="{filterModel,filterCallback}">
                        <DatePicker dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" placeholder="Filter Edited Date" />
                    </template>
                    <template #body="{data}">
                        {{ this.$formatDateTime(data.Edited_Date)}}
                    </template>
                </Column>
                <Column field="Edited_By" header="Edited By" dataType="date" :sortable="true">
                    <template #filter="{filterModel,filterCallback}">
                        <InputText type="text" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" placeholder="Filter Edited By" />
                    </template>
                </Column>
                <template #expansion="slotProps">
                    <div class="grid">
                        <div class="col-6">

                            <div class="field grid">
                                <label class="col-1"><b>{{$t('transporter_notes')}}</b></label>
                                <div class="col-9">
                                     <Textarea :autoResize="true" rows="3"  v-model="slotProps.data.Transporter_Notes" readonly style="min-width:40%"/>
                                </div>
                            </div>


                        </div>
                    </div>
                   


                    <div class="orders-subtable"  style="max-width:100vw">
                        <DataTable :value="slotProps.data.Details" style="min-width:80vw; max-width:100vw" responsiveLayout="scroll" :columnClass="headerName">
                            <Column field="Item_No" :header="$t('item_no')" style="width:5rem" ></Column>
                            <Column field="sap_no" :header="$t('sap_no')" >
                            </Column>
                             <Column field="Material_Name" :header="$t('material_code')" style="width:35vw" >
                            </Column>
                            <Column field="Qty" :header="$t('qty')"  >
                                <template #body="{data}">
                                    {{ $formatNumber(data.Qty)}}
                                </template>
                            </Column>
                            <Column field="os_qty" :header="$t('os_qty')"  >
                                <template #body="{data}">
                                    {{ $formatNumber(data.os_qty)}}
                                </template>
                            </Column>
                            <Column field="real_qty" :header="$t('real_qty')" >
                                <template #body="{data}">
                                    {{ $formatNumber(data.real_qty)}}
                                </template>
                            </Column>
                            <Column field="UOM" :header="$t('uom')" ></Column>
                            <Column field="Conversion_Type" :header="$t('conversion_type')" v-if="slotProps.data.Show_Conversion_Type == 'Y'" >
                            </Column>
                            <Column field="Conversion" :header="$t('conversion')"  v-if="slotProps.data.Show_Conversion_Type == 'Y'"  >
                                <template #body="{data}">
                                    {{ $formatNumber(data.Conversion)}}
                                </template>
                                <template #footer>
                                    <b>Total</b>
                                </template>
                            </Column>
                             <Column field="Conversion" :header="$t('conversion_total')"  v-if="slotProps.data.Show_Conversion_Type == 'Y'"  >
                                <template #body="{data}">
                                    {{ $formatNumber(data.Conversion * data.Qty)}}
                                </template>
                                <template #footer>
                                    {{ $formatNumber(totalConversion(slotProps.data.Details))}}
                                </template> 
                            </Column>
                        </DataTable>
                    </div>
                </template>
            </DataTable>
        </template>
    </Card>

   
</template>

<script>
    import IndexBase from '../Helper/IndexBase.vue'
    import AssignDriver from './_AssignDriver.vue'
    import Merge from './_Merge.vue'
    import ViewShipments from './_Shipments.vue'
    import TransporterAction from './_TransporterAction.vue'
    import History from './_History.vue'
    import CancelOrder from './_CancelOrder.vue'
    import ReassignDO from './_ReassignDO.vue'
    import MarkComplete from './_MarkComplete.vue'
    import ChangeStuffingDate from './_ChangeStuffingDate.vue'
    import EditOrder from './_EditOrder.vue'
    import EditAssign from './_EditAssign.vue'

    export default {
        name: "Order",
        components: {
            'IndexBase': IndexBase,
            'AssignDriver': AssignDriver,
            'Merge': Merge,
            'ViewShipments': ViewShipments,
            'TransporterAction': TransporterAction,
            'History': History,
            'CancelOrder': CancelOrder,
            'ReassignDO': ReassignDO,
            'MarkComplete': MarkComplete,
            'ChangeStuffingDate': ChangeStuffingDate,
            'EditOrder': EditOrder,
            'EditAssign': EditAssign
        },
        data() {
            return {
                dataModel: null,
                loading: false,
                totalRecords: 0,
                start: 0,
                stateKey: 'itm-state-order-' + this.$store.getters.getUsername,
                role: this.$store.getters.getRole,
                isAdmin: this.$store.getters.getIsAdmin,
                isUser: this.$store.getters.getIsUser,
                isTransporter: this.$store.getters.getIsTransporter || this.$store.getters.getIsCustomerVendor,
                isDriver: this.$store.getters.getIsDriver,
                sorts: null,
                lazyParams: {},
                filters: null,
                stateFilters: null,
                editorPath: "/Order/Editor",
                dataUrl: "order/list",
                masterListUrl: "order/master_list",
                canCreate: false,
                canEdit: false,
                canDelete: false,
                canView: false,
                selectedRow: null,
                selectedStatus: null,
                expandedRows: [],

                transporterStatusList: [],
                statusList: [],
                shipmentTypeList: []
            }
        },
        methods: {
            onAuth(event) {
                this.canCreate = event.canCreate;
                this.canEdit = event.canEdit;
                this.canDelete = event.canDelete;
                this.canView = event.canView;
            },
            onPage(event) {
                this.start = event.first;
                this.loadLazyData();
            },
            onSort(event) {
                this.sorts = event.multiSortMeta;
                this.loadLazyData();
            },
            onFilter() {
                this.loadLazyData();
            },
            onSelect(event){
                this.selectedRow = event.data;
            },
            onRowExpand(event){
                this.expandedRows = [];
                this.expandedRows.push(event.data);
            },
            editor(mode, id) {
                this.$router.push({ path: this.editorPath, query: { mode: mode, id: id } });
            },
            loadLazyData() {
               
                this.selectedRow = null;

                this.lazyParams = {
                    start: this.start,
                    sorts: this.dataSort,
                    filters: this.dataFilter
                };

                var self = this;

                if(!self.loading){
                    this.loading = true;

                    this.$axios.post(this.$API_URL + this.dataUrl, this.lazyParams)
                        .then((response) => {
                            if (response.data.success) {
                                self.dataModel = response.data.data;
                                self.totalRecords = response.data.totalRecords;
                            }
                            else {
                                self.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: 120000});
                            }

                            self.loading = false;
                        })
                        .catch(function (err) {
                            self.$toast.add({ severity: 'error', summary: "Error", detail: err.message, life: 120000});
                            self.loading = false;
                        });
                }

                
            },
            setFilters() {
                this.filters = {};
                var exportable = this.$refs.dt.columns.filter(c => c.props.field);
                for (var i = 0; i < exportable.length; i++) {
                    var filterValue = "";
                    var fieldName = exportable[i].props.field;
                    if(this.stateFilters){
                        var field = this.stateFilters[fieldName];
                        if(field) filterValue = field.value ? field.value : null;
                        else filterValue = null;
                    }
                    this.filters[fieldName] = { value: filterValue, matchMode: "contains" };

                    if(fieldName == "Status"){
                        if(filterValue)                            
                            this.selectedStatus = filterValue;
                        else this.selectedStatus = "ALL";
                    }

                }
            },
            onStateRestore(event) {
                this.start = event.first;
                this.stateFilters = event.filters;
                this.sorts = event.multiSortMeta;
            },
            onModalClose(){
                this.loadLazyData();
            },
            clearFilter(){
                this.filters = {};
                var exportable = this.$refs.dt.columns.filter(c => c.props.field);
                for (var i = 0; i < exportable.length; i++) {
                    var fieldName = exportable[i].props.field;
                    //console.log(exportable[i].props);

                    var filterValue = "";

                    if(fieldName == "Status") {
                        filterValue = this.selectedStatus;
                    }
                    else if(fieldName.includes("Date")){
                        filterValue = null;
                    }

                    this.filters[exportable[i].props.field] = { value: filterValue, matchMode: "contains" };
                }
                this.sorts = [];
                this.loadLazyData();
            },
            onChangeStatus(event){
                var status = event.value;

                this.filters.Status.value = status;
                this.$toast.removeAllGroups();
                this.loadLazyData();
            },
            viewOrder(){
                this.$router.push({ path: this.editorPath, query: { mode: this.$FORM_MODE_VIEW, id: this.selectedRow[0].Id } });
            },
            headerName(event){
                console.log(event);
            },
             totalConversion(details){
                var total = 0;

                if(details != null && details.length > 0){
                    for(var i=0; i<details.length;i++){
                        var qty = parseFloat(details[i].Qty);
                        var conversion = parseFloat(details[i].Conversion);

                        total += qty * conversion;
                    }
                }

                return total;
            }
        },
        mounted() {
            this.$emit('unblock-ui');
            this.setFilters();
            this.loadLazyData();
            this.$showToast();

            var self = this;

            this.$axios.get(this.$API_URL + this.masterListUrl)
                .then((response) => {
                    if (response.data.success) {
                        self.statusList = response.data.data.status;
                        self.shipmentTypeList = response.data.data.shipment_type;
                        self.transporterStatusList = response.data.data.transporter_status;
                        console.log(response.data.data)
                    }
                    else {
                        self.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: 120000});
                    }

                    self.loading = false;
                })
                .catch(function (err) {
                    self.$toast.add({ severity: 'error', summary: "Error", detail: err.message, life: 120000});
                    self.loading = false;
                });
        },
        computed: {
            filterBadge(){
                var badgeNumber = 0;

                this.dataFilter.filter(function(item) {                    
                    if(item.value && item.field != "Status"){
                        badgeNumber++;
                    }
                });

                return badgeNumber;
            },
            dataFilter() {
                var h = [];
                if (this.filters) {
                    for (const [key, value] of Object.entries(this.filters)) {
                        h.push({
                            field: key ? key : null,
                            value: value.value,
                            matchMode: value.matchMode
                        });
                    }
                }
                return h;
            },
            dataSort() {
                var h = [];
                if (this.sorts) {
                    for (var x = 0; x < this.sorts.length; x++) {
                        h.push({
                            field: this.sorts[x].field,
                            order: this.sorts[x].order == 1 ? "ASC" : "DESC"
                        });
                    }
                }
                return h;
            },
            needTransporterAction(){
                var data = this.selectedRow;
                if(data != null && data.length >= 1){
                    for(var i=0; i< data.length;i++){
                        if(!data[i].need_transporter_action){
                            return false;
                        }
                    }
                    return true;
                }
            },
            canAssignDriver(){
                var data = this.selectedRow;
                if(data != null && data.length == 1){
                    if(data[0].can_assign_driver){
                        return true;
                    }
                }
                return false;
            },
            canViewShipments(){
                var data = this.selectedRow;
                if(data != null && data.length == 1){
                    if(data[0].can_view_shipments){
                        return true;
                    }
                }
                return false;
            },
            canViewOrder(){
                var data = this.selectedRow;
                if(data != null && data.length == 1){
                    return true;
                }
                return false;
            },
            canViewHistory(){
                 var data = this.selectedRow;
                if(data != null && data.length == 1){
                    return true;
                }
                return false;
            },
            canEditOrder(){
                var data = this.selectedRow;
                if(data!= null && data.length == 1){
                    if(data[0].can_edit_order){
                        return true;
                    }
                }
                return false;
            },
            canCancelOrder(){
                var data = this.selectedRow;
                if(data != null && data.length == 1){
                    if(data[0].can_cancel_order){
                        return true;
                    }
                }
                return false;
            },
            canMarkComplete(){
                var data = this.selectedRow;
                if(data != null && data.length == 1){
                    if(data[0].can_mark_complete){
                        return true;
                    }
                }
                return false;
            },
            canUnmarkComplete(){
                var data = this.selectedRow;
                if(data != null && data.length == 1){
                    if(data[0].can_unmark_complete){
                        return true;
                    }
                }
            },
            canReassignDO(){
                var data = this.selectedRow;
                if(data != null && data.length == 1){
                    if(data[0].can_reassign_do){
                        return true;
                    }
                }
                return false;
            },
            canEditStuffingDate(){
                var data = this.selectedRow;
                if(data!=null && data.length==1){
                    return data[0].can_edit_stuffing_date
                }
                return false
            },
            canMerge(){
                var data = this.selectedRow;
                var canMerge = false;
                if(data != null && data.length > 1){
                    var transporterCode = "";
                    var truckTypeId = 0;
                    var loadingFrom = 0;
                    var loadingTo = 0;
                    var orderTypeId = 0;
                    var shipmentTypeCategory = "";
                    var freightCostValue = false;
                    var freightCost = 0;
                    var incotermId = "";
                    var documentType = "";
                    var multipleWeighing = "";

                    for(var i=0; i< data.length;i++){
                        var d = data[i];
                        var oTruckTypeId = d.Truck_Type_Id;
                        var oTransporterId = d.Transporter_Code;
                        var oShipmentType = d.shipment_type_category;
                        var oLoadingFrom = d.Loading_Destination_From_Id;
                        var oLoadingTo = d.Loading_Destination_To_Id;
                        var oOrderType = d.Order_Type_Id;
                        var oFreightValue = d.Freight_Cost_Value;
                        var oFreightCost= d.Freight_Cost;
                        var oIncoterm = d.Incoterm_Name;
                        var LangsirType = d.Langsir_Type;
                        var oDocumentType = d.Document_Type;
                        var oMultipleWeighing = d.Multiple_Weighing;

                        //|| dispatchStatus != this.$OrderStatus.ACCEPTED || d.Status != this.$OrderStatus.DISPATCHED || oShipmentType == this.$ShipmentTypeCategory.COLLECTIVE
                        if(!d.can_assign_driver){
                            canMerge = false;
                            break;
                        }

                        // if (orderTypeId == 0) orderTypeId = oOrderType;
                        // else if (orderTypeId != oOrderType) {
                        //     canMerge = false;
                        //     break;
                        // }

                        if (truckTypeId == 0) truckTypeId = oTruckTypeId;
                        else if (truckTypeId != oTruckTypeId) {
                            canMerge = false;
                            break;
                        }

                        if (transporterCode == "") transporterCode = oTransporterId;
                        else if (transporterCode != oTransporterId) {
                            canMerge = false;
                            break;
                        }

                        if (shipmentTypeCategory == "") shipmentTypeCategory = oShipmentType;
                        else if (shipmentTypeCategory != oShipmentType) {
                            canMerge = false;
                            break;
                        }

                        if (loadingFrom == 0) loadingFrom = oLoadingFrom;
                        else if (loadingFrom != oLoadingFrom) {
                            canMerge = false;
                            break;
                        }

                        if (loadingTo == 0) loadingTo = oLoadingTo;
                        else if (loadingTo != oLoadingTo) {
                            canMerge = false;
                            break;
                        }

                        if(i==0) freightCostValue = d.Freight_Cost_Value;

                        if(freightCostValue){
                            if(i==0){
                                freightCost = d.Freight_Cost;
                            }
                            else{
                                if(d.Freight_Cost == 0){

                                }
                                else if(d.Freight_Cost != 0 && freightCost == 0){
                                    
                                }
                                else if(freightCost != d.Freight_Cost){
                                    canMerge = false;
                                    break;
                                }
                            }
                        }

                        // if(incotermId == "") incotermId = oIncoterm;
                        // else if(incotermId != oIncoterm){
                        //     canMerge = false;
                        //     break;
                        // }


                        if(documentType == "") documentType = oDocumentType;
                        else if(documentType != oDocumentType){
                            canMerge = false;
                            break;
                        }

                        if(multipleWeighing == "") multipleWeighing = oMultipleWeighing;
                        else if(multipleWeighing != oMultipleWeighing){
                            canMerge = false;
                            break;
                        }


                        // if(LangsirType != ""){
                        //     canMerge = false;
                        //     break;
                        // }

                        canMerge = true;
                    }
                }
                return canMerge;
            },
            canEditAssignTransporter(){
                var data = this.selectedRow;
                if(data != null && data.length == 1){
                    return true;
                }
            },
           
        },
    }
</script>

<style #scoped>
    .p-card .p-card-content{
        margin:0!important;
        padding: 0 !important;
    }
</style>